/* STOP n GROW: galería, packs que cambian la variante del formulario, botones que abren EasySell, carrusel y barra fija. */
(function () {
  'use strict';
  if (window.__sng) return;
  window.__sng = true;

  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function galeria() {
    $$('[data-sng-gal]').forEach(function (gal) {
      var main = gal.querySelector('.sng-gal-main');
      var thumbs = $$('.sng-gal-thumbs button', gal);
      var dots = $$('.sng-gal-dots span', gal);
      function marcar() {
        var i = Math.round(main.scrollLeft / Math.max(1, main.clientWidth));
        thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
      }
      thumbs.forEach(function (t, j) {
        t.addEventListener('click', function () { main.scrollTo({ left: j * main.clientWidth, behavior: 'smooth' }); });
      });
      main.addEventListener('scroll', marcar, { passive: true });
      marcar();
    });
  }

  /* Cada pack es una variante real: actualiza el input "id" del formulario y la URL (?variant=) */
  function packs() {
    var grupo = document.querySelector('[data-sng-packs]');
    var input = document.querySelector('[data-sng-variante]');
    if (!grupo || !input) return;
    var precioBarra = document.querySelector('[data-sng-barra-precio]');
    $$('input[type=radio]', grupo).forEach(function (r) {
      r.addEventListener('change', function () {
        $$('.sng-pack', grupo).forEach(function (p) { p.classList.toggle('is-sel', p.contains(r)); });
        input.value = r.value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        if (precioBarra) {
          var t = r.closest('.sng-pack').querySelector('.sng-pack-t');
          precioBarra.textContent = (t ? t.firstChild.textContent.trim() + ' · ' : '') + r.getAttribute('data-precio');
        }
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          window.history.replaceState({}, '', u.toString());
        } catch (e) { /* sin URL API */ }
        document.dispatchEvent(new CustomEvent('sng:variante', { detail: { id: r.value } }));
      });
    });
  }

  /* Todos los botones abren el mismo formulario de pago al recibir que el buy-box */
  function comprar() {
    var es = document.querySelector('#sng-buybox .es-popup-button') || document.querySelector('.es-popup-button');
    if (es) { es.click(); return; }
    var btn = document.querySelector('#sng-buybox [type="submit"]');
    if (btn) { btn.click(); return; }
    var box = document.getElementById('sng-buybox');
    if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function barra() {
    var b = document.querySelector('[data-sng-barra]');
    var ancla = document.querySelector('#sng-buybox .sng-form');
    if (!b || !ancla || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) {
      var on = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      if (document.querySelector('#es-sticky')) on = false;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-hidden', on ? 'false' : 'true');
      var btn = b.querySelector('button');
      if (btn) btn.tabIndex = on ? 0 : -1;
    }).observe(ancla);
  }

  function carruseles() {
    $$('[data-sng-carrusel]').forEach(function (w) {
      var fila = w.querySelector('.sng-razones-fila');
      $$('[data-dir]', w).forEach(function (b) {
        b.addEventListener('click', function () {
          var paso = fila.firstElementChild ? fila.firstElementChild.getBoundingClientRect().width + 16 : 260;
          fila.scrollBy({ left: paso * Number(b.getAttribute('data-dir')), behavior: 'smooth' });
        });
      });
    });
  }

  /* Videos: se reproducen en silencio solo cuando están en pantalla */
  function videos() {
    var vs = $$('[data-sng-video]');
    if (!vs.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.src && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.pause(); }
      });
    }, { rootMargin: '120px' });
    vs.forEach(function (v) { io.observe(v); });
  }

  /* Reseñas del buy-box: puntos, avance automático cada 5 s y pausa al tocar */
  function opiniones() {
    $$('[data-sng-opis]').forEach(function (w) {
      var fila = w.querySelector('.sng-opis-fila');
      var dots = $$('.sng-opis-dots button', w);
      var n = fila.children.length, pausa = false;
      function actual() { return Math.round(fila.scrollLeft / Math.max(1, fila.clientWidth)); }
      function ir(i) { fila.scrollTo({ left: i * (fila.clientWidth + 12), behavior: 'smooth' }); }
      function marcar() { var i = actual(); dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); }); }
      dots.forEach(function (d, j) { d.addEventListener('click', function () { pausa = true; ir(j); }); });
      fila.addEventListener('scroll', marcar, { passive: true });
      ['touchstart', 'mouseenter'].forEach(function (ev) { fila.addEventListener(ev, function () { pausa = true; }, { passive: true }); });
      marcar();
      if (n > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        setInterval(function () { if (!pausa && !document.hidden) ir((actual() + 1) % n); }, 5000);
      }
    });
  }

  /* Bloques que aparecen al hacer scroll: cada [data-sng-revelar] recibe .is-in al entrar en pantalla (una sola vez).
     Sin IntersectionObserver o con movimiento reducido, se muestran de entrada. */
  function revelar() {
    var els = $$('[data-sng-revelar]');
    if (!els.length) return;
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (quieto || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    document.documentElement.classList.add('sng-anima');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
    els.forEach(function (e) { io.observe(e); });
  }

  function iniciar() {
    revelar();
    opiniones();
    galeria();
    packs();
    barra();
    carruseles();
    videos();
    $$('[data-sng-cta]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); comprar(); }); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
